import { schema } from 'normalizr';

const benefitPlan = new schema.Entity('plans', undefined, {
  idAttribute: 'id',
});

export const benefitPlansSchema = {
  plans: [benefitPlan],
};
